export const viewport = window.visualViewport.width;
export const booksList = document.querySelector(".js-bookslist");
export const topBooks = document.querySelector(".js-all");
